import { useEffect, useState } from 'react';

import { errorTextkeys } from '~/components/limits/spending-limit/upload-docs/constants';
import { DocumentTypes } from '~/components/limits/spending-limit/upload-docs/types';
import { fetchDocuments } from '~/components/limits/spending-limit/upload-docs/utils';
import { NOTIFICATION_ID } from '~/components/limits/spending-limit/utils/constant';
import { hideQueuedNotification, showQueuedNotification } from '~/components/notifications/ducks/actions';
import useTranslations from '~/components/translation/use-translations';
import { APIResponseStatuses } from '~/services/api-new';
import { useAppDispatch } from '~/store/types';

const useFetchDocs = () => {
	const dispatch = useAppDispatch();

	const [loading, setLoading] = useState(false);
	const [result, setResult] = useState<DocumentTypes>([]);

	const { translations: t } = useTranslations(errorTextkeys);

	const renderError = (message: string) => {
		dispatch(hideQueuedNotification(NOTIFICATION_ID));
		dispatch(
			showQueuedNotification({
				message,
				color: 'red',
				autoHide: true,
				openInSidebar: true,
				id: NOTIFICATION_ID
			})
		);
	};

	const queryFn = async () => {
		setLoading(true);

		try {
			const response = await fetchDocuments();

			if (response.status === APIResponseStatuses.SUCCESS) {
				setResult(response.result?.reverse());

				return;
			}

			renderError(t.MOBILE_UPLOAD_DOCUMENTS_FETCH_API_ERROR);
		} catch (_) {
			renderError(t.MOBILE_UPLOAD_DOCUMENTS_FETCH_API_ERROR);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		// eslint-disable-next-line @typescript-eslint/no-floating-promises
		queryFn();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return { data: result, loading, queryFn };
};

export default useFetchDocs;
